module.exports = __webpack_public_path__ + "static/media/icon_finance.e6117ec9.svg";